'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _d3Selection = require('d3-selection');

require('d3-transition');

var _d3Interpolate = require('d3-interpolate');

var _d3Array = require('d3-array');

var _d3Timer = require('d3-timer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hawsehole = function (_React$PureComponent) {
  _inherits(Hawsehole, _React$PureComponent);

  function Hawsehole(props) {
    _classCallCheck(this, Hawsehole);

    var _this = _possibleConstructorReturn(this, (Hawsehole.__proto__ || Object.getPrototypeOf(Hawsehole)).call(this, props));

    _this.state = {
      current: null,
      top: false,
      anchors: [],
      anchorRoot: { children: [] }
    };
    _this.hashConnected = false;

    _this.handleHashchange = _this.handleHashchange.bind(_this);
    return _this;
  }

  _createClass(Hawsehole, [{
    key: 'transitionScrollTo',
    value: function transitionScrollTo(name) {
      var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _props = this.props,
          hash = _props.hash,
          offset = _props.offset,
          duration = _props.duration,
          ease = _props.ease,
          delay = _props.delay;


      var anchorNode = (0, _d3Selection.select)((0, _reactDom.findDOMNode)(this)).select('a[name=\'' + name + '\']').node();
      if (!anchorNode) return;

      if (hash) {
        var push = active && hash === 'push';
        if (window.history[push ? 'pushState' : 'replaceState'] != null) {
          window.history[push ? 'pushState' : 'replaceState']({}, "", '#' + name);
        } else {
          window.location[push ? 'assign' : 'replace']('#' + name);
        }
      }

      var before = window.pageYOffset,
          after = this.props.anchorTop(anchorNode),
          interpolator = (0, _d3Interpolate.interpolate)(before, after);
      var transition = (0, _d3Selection.select)((0, _reactDom.findDOMNode)(this)).transition().duration(typeof duration === 'function' ? duration(before, after) : duration).delay(typeof delay === 'function' ? delay(before, after) : delay);
      if (ease) transition.ease(ease);
      return transition.tween('scroll', function () {
        return function (t) {
          window.scrollTo(0, interpolator(t));
        };
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      var _this2 = this;

      var _state = this.state,
          anchors = _state.anchors,
          current = _state.current,
          top = _state.top,
          anchorTops = anchors.map(function (_ref) {
        var node = _ref.node;
        return _this2.props.anchorTop(node);
      }),
          end = window.pageYOffset + (0, _reactDom.findDOMNode)(this).getBoundingClientRect().bottom,
          index = (0, _d3Array.bisect)([].concat(_toConsumableArray(anchorTops), [end]), window.pageYOffset + 1 - 1e-6) - 1,
          nextCurrent = (anchors[index] || {}).name,
          nextTop = Math.abs(window.pageYOffset - anchorTops[index]) < 1;

      if (nextCurrent !== current || nextTop !== top) {
        this.setState({ current: nextCurrent, top: nextTop });
      }
    }
  }, {
    key: 'findAnchors',
    value: function findAnchors() {
      var list = [],
          stack = [{ children: [], headingLevel: 0 }];

      (0, _d3Selection.select)((0, _reactDom.findDOMNode)(this)).selectAll('a[name]').each(function () {
        var match = this.children[0] && this.children[0].tagName.match(/h(\d+)/i),
            headingLevel = match ? +match[1] : Infinity;

        var anchor = {
          node: this,
          name: this.getAttribute('name'),
          children: [],
          headingLevel: headingLevel
        };
        list.push(anchor);

        while (headingLevel <= stack[stack.length - 1].headingLevel) {
          stack.pop();
        }stack[stack.length - 1].children.push(anchor);
        stack.push(anchor);
      });

      this.setState({ anchors: list, anchorRoot: stack[0] });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      this.timer = (0, _d3Timer.timer)(function () {
        if (_this3.prevPageYOffset !== window.pageYOffset) _this3.handleScroll();
        _this3.prevPageYOffset = window.pageYOffset;
      });
      this.findAnchors();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.timer && this.timer.stop();
      if (this.props.hash) this.disconnectHash();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      (0, _d3Selection.select)((0, _reactDom.findDOMNode)(this)).selectAll('a[name]').classed(this.props.currentClassName, false).classed(this.props.topClassName, false).filter('a[name=\'' + this.state.current + '\']').classed(this.props.currentClassName, true).classed(this.props.topClassName, this.state.top);

      if (!this.hashConnected && this.props.hash) this.connectHash();else if (this.hashConnected && !this.props.hash) this.disconnectHash();

      if (prevProps.children !== this.props.children) this.findAnchors();
    }
  }, {
    key: 'handleHashchange',
    value: function handleHashchange(event) {
      var transition = this.transitionScrollTo(window.location.hash.slice(1));
      if (transition && event) event.preventDefault();
    }
  }, {
    key: 'connectHash',
    value: function connectHash() {
      this.handleHashchange();
      window.addEventListener('hashchange', this.handleHashchange);
      window.history.scrollRestoration = 'manual';
      this.hashConnected = true;
    }
  }, {
    key: 'disconnectHash',
    value: function disconnectHash() {
      window.removeEventListener('hashchange', this.handleHashchange);
      window.history.scrollRestoration = 'auto';
      this.hashConnected = false;
    }
  }, {
    key: 'renderAnchors',
    value: function renderAnchors(anchors) {
      var _this4 = this;

      var _props2 = this.props,
          currentClassName = _props2.currentClassName,
          listNames = _props2.listNames;
      var current = this.state.current;


      return !anchors.length ? null : _react2.default.createElement(
        'ul',
        null,
        anchors.map(function (anchor) {
          return _react2.default.createElement(
            'li',
            { key: anchor.name },
            _react2.default.createElement(
              'a',
              {
                href: '#' + anchor.name,
                className: anchor.name === current ? currentClassName : '',
                onClick: function onClick(event) {
                  _this4.transitionScrollTo(anchor.name, true);
                  event.preventDefault();
                }
              },
              listNames ? anchor.node.name : anchor.node.textContent
            ),
            _this4.renderAnchors(anchor.children)
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          Nav = _props3.navComponent,
          Component = _props3.component,
          style = _props3.style,
          className = _props3.className,
          children = _props3.children;
      var anchorRoot = this.state.anchorRoot;


      var nav = Nav && _react2.default.createElement(
        Nav,
        null,
        this.renderAnchors(anchorRoot.children)
      );
      return _react2.default.createElement(
        Component,
        {
          className: className,
          style: style
        },
        nav,
        children
      );
    }
  }]);

  return Hawsehole;
}(_react2.default.PureComponent);

Hawsehole.defaultProps = {

  // Set to true to enable reading and writing URL hash,
  // or to 'push' to also enable pushState on nav click
  hash: false,

  // Tag or React component to wrap nav, or null for no nav
  navComponent: 'nav',

  // Set to true to show anchor name in nav, instead of textContent
  listNames: false,

  // Class assigned to prominent anchor in viewport, and corresponding nav li
  currentClassName: 'current',

  // Class also assigned to current anchor if at viewport top
  topClassName: 'top',

  // Function for computing each anchor node's document offset
  anchorTop: function anchorTop(node) {
    return node.getBoundingClientRect().top + window.pageYOffset;
  },

  /*
   * Scroll transition
   */

  // If function passed for duration or delay, receives scroll position before and after as arguments
  delay: 0, // (in ms)
  duration: function duration(a, b) {
    return Math.pow(Math.abs(a - b), 0.75) + 300;
  }, // (in ms)
  ease: null, // defaults to D3's default easing


  /*
   * Container component
   */

  // Tag or React component to wrap nav component and children
  component: 'div',

  // Passed along to container
  className: null,
  style: null

};
exports.default = Hawsehole;


//////////////////
// WEBPACK FOOTER
// ./~/hawsehole/dist/index.js
// module id = 256
// module chunks = 0